// extracted by mini-css-extract-plugin
export default {"container":"AuthButton_container__G2PGt","left_container":"AuthButton_left_container__QBHlM"};